// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"6d9efdb2","672":"928f08e0","677":"b8f5be13","748":"63334d65","754":"0d727245","769":"b1d4eeff","855":"c151f362","859":"e4be55a1","930":"ffe3f77c","932":"25a97a30","976":"009459db"}[chunkId] + ".chunk.js";
};